import _regeneratorRuntime from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _defineProperty2 from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _Date$now from "@babel/runtime-corejs3/core-js-stable/date/now";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import { fastOptionsMerge } from './helper';
import { HttpEventTypes } from './common';

function defaultOnResponse(value) {
  return _Promise.resolve(value);
}

function defaultOnError(value) {
  return _Promise.reject(value);
}

function defaultOnException(error) {
  return _Promise.reject(error);
}

function defaultOnTrace() {}

function defaultOnFetch(url, options) {
  var fetchCall = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fetch;
  return fetchCall(url, options);
}

export var HttpTransport = function HttpTransport(handlers) {
  var _this = this;

  _classCallCheck(this, HttpTransport);

  _defineProperty(this, "onAuth", void 0);

  _defineProperty(this, "onResponse", void 0);

  _defineProperty(this, "onErrorResponse", void 0);

  _defineProperty(this, "onException", void 0);

  _defineProperty(this, "onTrace", void 0);

  _defineProperty(this, "onFetch", void 0);

  _defineProperty(this, "fetch", function _callee(url, method, opts) {
    var options, start, fetchWithTrace, response;
    return _regeneratorRuntime.async(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _objectSpread({}, opts, {
              method: method
            });
            start = _Date$now();

            fetchWithTrace = function fetchWithTrace() {
              var fetchOptions, authOptions;
              return _regeneratorRuntime.async(function fetchWithTrace$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _this.onTrace(HttpEventTypes.request, {
                        url: url,
                        options: options
                      });

                      fetchOptions = options;

                      if (!_this.onAuth) {
                        _context.next = 7;
                        break;
                      }

                      _context.next = 5;
                      return _regeneratorRuntime.awrap(_this.onAuth());

                    case 5:
                      authOptions = _context.sent;
                      fetchOptions = fastOptionsMerge(options, authOptions);

                    case 7:
                      return _context.abrupt("return", fetch(url, fetchOptions));

                    case 8:
                    case "end":
                      return _context.stop();
                  }
                }
              }, null, null, null, Promise);
            };

            _context2.prev = 3;
            _context2.next = 6;
            return _regeneratorRuntime.awrap(_this.onFetch(url, options, fetchWithTrace));

          case 6:
            response = _context2.sent;

            if (!response.ok) {
              _context2.next = 10;
              break;
            }

            _this.onTrace(HttpEventTypes.response, {
              url: url,
              options: options,
              response: response,
              duration: _Date$now() - start
            });

            return _context2.abrupt("return", _this.onResponse(response));

          case 10:
            _this.onTrace(HttpEventTypes.error, {
              url: url,
              options: options,
              error: response,
              duration: _Date$now() - start
            });

            return _context2.abrupt("return", _this.onErrorResponse(response));

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](3);

            _this.onTrace(HttpEventTypes.exception, {
              url: url,
              options: options,
              exception: _context2.t0.toString(),
              duration: _Date$now() - start
            });

            return _context2.abrupt("return", _this.onException(_context2.t0));

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, null, null, [[3, 14]], Promise);
  });

  var _ref = handlers || {},
      onAuth = _ref.onAuth,
      onErrorResponse = _ref.onErrorResponse,
      onException = _ref.onException,
      onFetch = _ref.onFetch,
      onResponse = _ref.onResponse,
      onTrace = _ref.onTrace;

  this.onAuth = onAuth;
  this.onFetch = onFetch || defaultOnFetch;
  this.onResponse = onResponse || defaultOnResponse;
  this.onErrorResponse = onErrorResponse || defaultOnError;
  this.onException = onException || defaultOnException;
  this.onTrace = onTrace || defaultOnTrace;
};